var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavsmallarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.93 0.794983L6.33997 5.37498L1.74997 0.794983L0.339966 2.20498L6.33997 8.20498L12.34 2.20498L10.93 0.794983Z",
    fill: "#7E7E8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavsmallarrow);
export default __webpack_public_path__ + "static/media/navsmallarrow.31ed498db54abc8af7a72c429b1760d9.svg";
export { ForwardRef as ReactComponent };